<template>
	<LazyLoadWrapper>
		<div
			v-editable="blok"
			class="flex flex-col pt-[50px] pb-[26px] text-base mb-12 mt-12 w-full bg-gray-300"
		>
			<div class="main-wrapper w-full mx-auto">
				<p class="text-3xl mb-8 text-center">{{ blok.title }}</p>
				<p
					v-show="blok.text"
					class="mb-8 text-[22px] leading-7 text-center text-gray-600"
				>
					{{ blok.text }}
				</p>
				<div v-if="featuredProducts?.Items?.length > 0">
					<StoryblokComponent
						v-for="carousel in blok.carousel"
						:key="carousel._uid"
						:blok="carousel"
						:slides="featuredProducts?.Items"
						:type-of-slide="ItemType.PRODUCT"
					/>
				</div>
			</div>
		</div>
	</LazyLoadWrapper>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import type { ProductsByIds } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { BlokFeaturedProducts } from "~/types/storyblok/storyblok";
import { ItemType } from "~/utils/constants";
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";

interface Props {
	blok: BlokFeaturedProducts;
}

const { blok } = defineProps<Props>();

const { listProductsByIds } = useNorcePwa();

const featuredProducts = ref<ProductsByIds>();

const getFeaturedProducts = async () => {
	const idSeed = blok.selected_products.map((productId) => productId).join(",");

	const products = await listProductsByIds({
		idSeed
	});

	featuredProducts.value = products;
};
onMounted(() => {
	getFeaturedProducts();
});
</script>
